import { API_PATHS } from "./apiPaths";
import { axiosInstance } from "./axiosSetup";

export async function getSignalCheckReports(selectedJournalIds) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      journal_ids: selectedJournalIds.join(',')
    },
    path: API_PATHS.SIGNALCHECK_REPORTS,
    method: "get",
  });
}


export async function getMofsScreenshotUrl(value) {
  return axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: { value },
    path: API_PATHS.MOFS_SCREENSHOT_URL_BY_VALUE,
    method: "get",
  });
}
